import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { BsBasket } from "react-icons/bs";
import { CartContext } from "../context/CartContext";
import { analytics } from "../utils/analytics";
import { isProductInStock } from "../utils/productAvailability";
import { buildProductDetailPath } from "../utils/productLinks";
import { getProductImage } from "../utils/productImages";
import { getProductDisplayName } from "../utils/productDisplayName";
import {
  getProductDiscountPercent,
  getProductDiscountPrice,
  getProductEffectivePrice,
  getProductRegularPrice,
} from "../utils/productSorting";
import ProductRatingSummary from "./ProductRatingSummary";
import DiscountBadge from "./DiscountBadge";
import styles from "../pages/Products.module.css";

const formatPrice = (value) =>
  new Intl.NumberFormat("uk-UA", {
    maximumFractionDigits: 0,
  }).format(Number(value) || 0);

const DiscountedProductCard = ({ product }) => {
  const { addToCart } = useContext(CartContext);
  const [, setSuccessMessage] = useState("");

  const discountPercent = Math.round(getProductDiscountPercent(product));

  if (discountPercent <= 0) {
    return null;
  }

  const isOutOfStock = !isProductInStock(product);
  const regularPrice = getProductRegularPrice(product);
  const discountPrice = getProductDiscountPrice(product);
  const currentPrice = getProductEffectivePrice(product);
  const promotionLinkState = {
    fromPromotions: true,
    sourcePath: "/promotions",
  };

  return (
    <div className={styles.productCard}>
      <Link
        to={buildProductDetailPath(product)}
        state={promotionLinkState}
        className={styles.productLink}
      >
        <div className={styles.productCardImageWrap}>
          <img
            src={getProductImage(product, "thumbnail")}
            alt={product.name}
            className={`${styles.productImage} ${
              isOutOfStock ? styles.mutedProductImage : ""
            }`}
            loading="lazy"
            decoding="async"
            onError={(event) => {
              event.currentTarget.src = "/images/default-product.jpg";
            }}
          />

          {!isOutOfStock && <DiscountBadge percent={discountPercent} />}
        </div>

        <h4 className={styles.productTitle}>
          {getProductDisplayName(product)}
        </h4>
      </Link>

      <ProductRatingSummary product={product} />

      <div className={styles.cardBottomCentered}>
        {isOutOfStock ? (
          <>
            <p className={styles.disabledPrice}>{formatPrice(regularPrice)} ₴</p>
            <p className={styles.outOfStockLabel}>Немає в наявності</p>
          </>
        ) : (
          <>
            <div className={styles.priceWrapperCentered}>
              {regularPrice > discountPrice && (
                <span className={styles.oldPrice}>{formatPrice(regularPrice)} ₴</span>
              )}
              <span className={styles.discountPrice}>{formatPrice(currentPrice)} ₴</span>
            </div>

            <button
              className={styles.addToCartIconButtonBottom}
              onMouseUp={(event) => event.currentTarget.blur()}
              onClick={(event) => {
                event.preventDefault();
                addToCart(product, 1);
                analytics.addToCart(product);
                setSuccessMessage("Товар додано до кошика!");
                setTimeout(() => setSuccessMessage(""), 3000);
              }}
              title="Додати в кошик"
              disabled={isOutOfStock}
            >
              <BsBasket />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default DiscountedProductCard;
